import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { RouterModule } from '@angular/router';
import { UigAddToSavedCartComponent } from './uig-add-to-saved-cart.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ConfigModule.withConfig(<CmsConfig>{
      cmsComponents: {
        AddToSavedCartsComponent: {
          component: UigAddToSavedCartComponent,
        },
      },
    }),
    I18nModule,
    UrlModule,
  ],
  declarations: [UigAddToSavedCartComponent],
  exports: [UigAddToSavedCartComponent]
})
export class UigAddToSavedCartModule { }
